import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      activeTab: -1,
      language: ''
    };
  },
  props: ['activeIndex', 'language'],
  methods: {
    toUrl(type) {
      let query = this.$route.query;
      if (type) {
        query.isPersonalCenter = 1;
      }
      if (this.$route.name == 'audios' && type) {
        return window.open(`${window.location.href}&isPersonalCenter=1`);
      }
      this.$router.push({
        name: !type ? 'exhibitions' : 'audios',
        query
      });
    }
  },
  created() {
    this.activeTab = this.activeIndex || -1;
  }
};